import PreOrderForm from '@front/blocks/dist/pre-order-form';
import { createPopper } from '@popperjs/core';
import queryString from 'query-string';

import './components/header/header';
import './components/seo-collapse';
import './components/accordion';
import './components/hero-section/hero-section';
import './components/top-writers/top-writers';
import './components/reviews/reviews';
import './components/slider/slider';
import './components/services/services';
import './components/stats/stats';
import './components/livechat';
import './utils/lazy-img';
// import './utils/animation';
import './utils/helpers/web-vitals';

import getAboutUsModal from './components/modal/getAboutUsModal';
import getDiscountModal from './components/modal/getDiscountModal';
import { openModal } from './components/modal/modal';
import initTabs from './components/tabs/tabs';
import renderer from './utils/renderer';
import {
  _isMobile,
  _isOnPage,
  _isOnScreen,
  _on,
  _once,
  _scrollTo,
  addTooltip,
  configureShadowArea,
  createTooltipTemplate,
} from './utils';

import '@splidejs/splide-4/dist/css/splide.min.css';
import './styles/index.css';
import './components/tools/tools-navigation.css';
import './components/hero-section/hero-section.css';
import './components/reviews/reviews.css';
import './components/top-writers/top-writers.css';
import './components/tabs/tabs.css';
import './components/accordion/accordion.css';
import './components/faqs/faqs.css';
import './components/seo-collapse/seo-collapse.css';
import './components/modal/modal.css';
import './components/drawer/drawer.css';
import './components/back-to-top/back-to-top.css';
import './components/cookie/cookie.css';

_on('click', 'js--scroll-to-reviews', () => {
  _scrollTo('#reviews', { threshold: 20 });
});

_on('click', 'js--surprise', () => {
  openModal({
    id: 'surprise',
    content: getDiscountModal(),
    contentClasses: 'bg-white text-grey-500 max-w-[600px]',
    closeButtonClasses: 'text-blue-500 hover:text-blue-900',
  });
});

_on('click', 'js--about-us', () => {
  openModal({
    id: 'about-us',
    content: getAboutUsModal(),
    contentClasses: 'bg-white text-grey-500 max-w-[600px]',
    closeButtonClasses: 'text-blue-500 hover:text-blue-900',
  });
});

_on('click', 'js--copy-promo-code', function (event) {
  navigator.clipboard.writeText('SPECIAL10');

  const target = event.target.closest('.js--copy-promo-code');
  const tooltip = createTooltipTemplate('Copied!');
  document.body.appendChild(tooltip);
  createPopper(target, tooltip, {
    placement: 'top',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  target.addEventListener('mouseleave', () => {
    const tooltip = document.getElementById('tooltip');
    if (tooltip) {
      tooltip.remove();
    }
  });
});

_on('click', 'js--request-writer', ({ target }) => {
  window.bbSetOrderInitial({ domain: '/', writer_req_slug: target.dataset.slug, threshold: 240 });
  window.location.href = '/registration.html';
});

// @todo add helpcrunch
_on('click', 'js--trigger-livechat', () => {});

/**
 * Expand element from data-target or next sibling
 *
 * Hidden element should have {hidden} class
 */
_on('click', 'js--read-more', ({ target }) => {
  const nextElementSibling = (target as HTMLElement).nextElementSibling;
  const dataTarget = (target as HTMLElement).getAttribute('data-target');

  const hiddenEl = dataTarget ? document.querySelector(dataTarget) : nextElementSibling;

  if (hiddenEl) {
    target.remove();
    hiddenEl.classList.remove('hidden');
  }
});

const tooltips = document.querySelectorAll('[data-tooltip]');
if (tooltips.length) {
  tooltips.forEach(selector => addTooltip(selector));
}

if (_isMobile()) {
  _isOnScreen('.js--mention-mobile', () => {
    const scrollArea = document.querySelector('.js--mention-mobile') as HTMLElement;
    configureShadowArea(scrollArea);
    _once(() => {
      scrollArea.addEventListener('scroll', function () {
        configureShadowArea(scrollArea);
      });
    })();
  });
}

_isOnPage('.js--autofocus', () =>
  setTimeout(() => {
    if (window.bb_version && document.querySelector('.bb-input[name="email"]')) {
      window.bbSetOrder({ threshold: 400 });
    }
  }, 1000),
);

initTabs('.js--customer-faq-tabs');

_on('click', 'js--order-paper-type', e => {
  const paper_type = parseInt(e.target.dataset.type, 10) || 200;
  window.open(`/registration.html?${queryString.stringify({ paper_type })}`, '_blank');
});

_isOnPage('.js--set-paper-type', () => {
  const paper_type = queryString.parse(window.location.search).paper_type;
  if (paper_type) {
    window.bbSetOrder({ paper_type });
  }
});

_isOnScreen(
  '.tiktok-reviews',
  _once(() => {
    const script = document.createElement('script');
    // Set the 'src' attribute to the TikTok embed URL
    script.src = 'https://www.tiktok.com/embed.js';
    script.async = true;
    document.body.appendChild(script); // or document.body.appendChild(script);
  }),
);

/**
 * Scroll to become writer form
 */

_on('click', 'js--become-writer', function () {
  window.bbScrollToBecomeWriter(200);
});

renderer('[data-pre-order]', PreOrderForm);
